import { CategoryActionTypes } from "../action-types/categoryTypes";

export const listCategories = (content) => {
  return (dispatch) => {
    dispatch({
      type: CategoryActionTypes.LIST_CATEGORIES,
      payload: content,
    });
  };
};